import { html } from 'lit';
const Publish =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.035 11.25h3.209c.083-2.207.529-4.22 1.232-5.75q.215-.471.478-.9a8.01 8.01 0 0 0-4.92 6.65M12 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19M12 4c-.64 0-1.459.596-2.161 2.126-.6 1.306-1.012 3.097-1.094 5.124h6.51c-.082-2.027-.494-3.818-1.094-5.124C13.46 4.596 12.64 4 12 4m4.756 7.25c-.083-2.207-.529-4.22-1.232-5.75a9 9 0 0 0-.478-.9 8.01 8.01 0 0 1 4.92 6.65zm-1.5 1.5H8.744c.082 2.027.494 3.818 1.094 5.124C10.54 19.404 11.36 20 12 20s1.459-.596 2.161-2.126c.6-1.306 1.012-3.097 1.094-5.124m-.21 6.65a9 9 0 0 0 .478-.9c.704-1.53 1.15-3.543 1.232-5.75h3.21a8.01 8.01 0 0 1-4.92 6.65m-6.092 0a9 9 0 0 1-.478-.9c-.703-1.53-1.15-3.543-1.232-5.75h-3.21a8.01 8.01 0 0 0 4.92 6.65" clip-rule="evenodd"/>
  </svg>
`;
export default Publish;
